<nx-table-header
  class="text-[1rem]"
  label="Rechnungsliste">
</nx-table-header>

<p-table
  [value]="invoices"
  [totalRecords]="invoices?.length"
  [loading]="isLoading"
  scrollHeight="flex">
  <ng-template pTemplate="header">
    <tr>
      <th>Nummer</th>
      <th>Datum</th>
      <th>Betrag</th>
      <th>Status</th>
      <th></th>
    </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice>
      <tr>
          <td>{{invoice?.number? invoice?.number: '–'}}</td>
          <td>{{invoice?.date? (invoice?.date | date:'dd.MM.yyyy'): '-'}}</td>
          <td>{{paymentService?.getCurrency(invoice?.amount, invoice?.currency, this.currencyPipe)}}</td>
          <td>{{invoice?.state? invoice?.state: '-'}}</td>
          <td class="text-right">
            <nx-default-button
              [tooltip]="'Rechnung herunterladen'"
              [style]="'dark'"
              (click)="downloadInvoice(invoice.downloadLink)"
              [label]="'herunterladen'">
            </nx-default-button>
          </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="emptyMessage">Keine Rechnungen vorhanden.</td>
      </tr>
    </ng-template>
</p-table>